export default {
  history: 'Historia',
  version: 'Wersja',
};
